//2018-03-06

'use strict';

window.tagManagerHelper =
{
	productClick:function(productThumb, event)
	{	//2018-03-06
		event = event || window.event;
		const clickTarget = event.target || event.srcElement;
		
		if((clickTarget.nodeName === 'BUTTON' && clickTarget.classList.contains('addToCart')) || typeof(window.google_tag_manager) === 'undefined') return true;
		
		const newTabOrWindow = !!(event.metaKey || event.ctrlKey || event.shiftKey);		//⌘ = new tab (macos), ^ = new tab (windows), ⇧ = new window
		
		const dataAttribute = productThumb.getAttribute('data-data-layer-data') || productThumb.getAttribute('data-gtm-data');
		
		const productData = JSON.parse(dataAttribute);
		
		const priceDataElement = productThumb.querySelector('div.prices');

		const priceDataAttribute = priceDataElement?.getAttribute('data-price');
		const price = JSON.parse(priceDataAttribute);

		//2025-10-09 In the very extreme edge cases where the ESI fragment hasn't been received from the API, they do not want us to log the click at all
		//(this should never happen since varnish uses stale cache while revalidating),
		if(typeof(price) !== 'number')
		{
			console.warn('tagManagerHelper.productClick: Missing price data, not logging productClick event for product: '+productData.id);
			return;
		}

		productData.price = price;

		const productURL = productThumb.querySelector('a[href]').href;

		productData.position = [...productThumb.parentNode.children].indexOf(productThumb);
		
		window.dataLayer.push
		({
			'event':'productClick',
			'ecommerce':
			{
				'click':
				{
					//'actionField': {'list': 'Search Results'},      // Optional list property.
					'products':[productData]
				}
			},
			'eventCallback':function()
			{
				if(!newTabOrWindow) document.location = productURL;
			}
		});
		
		return newTabOrWindow;
	}
};
